import React from 'react';

import RecordsScreen from '/component/layout/RecordsScreen';
import {COACH_REPORT} from '/enum/popover.enum';
import {REPORT_CARD_CONTENT_TEAM_RANK} from '/enum/reportCard.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {withHOC} from '/util/hoc.util';

import {ReportProps} from '../Report.types';
import withRecordPopover from '../withRecordPopover';

import {CoachesBelowRankContent} from './CoachesBelowRankContent';
import reportPayload from './reportPayload';

export const CoachesBelowRankReport = ({
  loadingData = {total: 0},
  tt = (key: string, defaultValue?: string) => defaultValue || '',
  showRecordPopover = () => {},
}: ReportProps) => {
  return (
    <RecordsScreen
      {...reportPayload}
      title={tt('title', 'Below Rank')}
      description={tt(
        'description',
        'Coaches who are currently performing under their highest rank achieved.',
      )}
      contentProps={{loadingData, showRecordPopover}}
      contentComponent={CoachesBelowRankContent}
    />
  );
};

export default withHOC(
  withTranslation('report.coachesBelowRank'),
  withRecordPopover({
    reportPayload,
    popoverName: COACH_REPORT,
    popoverContentName: REPORT_CARD_CONTENT_TEAM_RANK,
    popoverContentProps: {
      renderTitle: () =>
        withTranslation.ts('reportRecordTitle.belowRank', 'Below Rank'),
    },
  }),
)(CoachesBelowRankReport);
